import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ReportView from "./ReportView";
import logoLf23 from "../../assets/logo_lf23.png";
import "./ReportPubblico.css";

/**
 * Pagina pubblica del report condivisibile: /r/:token, senza login.
 * Legge lo snapshot da GET /api/public/report/:token e lo passa a ReportView; le foto
 * arrivano dal proxy pubblico dello stesso token. Un token spento o inesistente da'
 * la stessa schermata "non disponibile": dall'esterno non si distingue.
 */

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

const Schermata = ({ titolo, testo, spinner = false }) => (
    <div className="rp-stato">
        <div className="rp-stato-card">
            {spinner ? <div className="rp-stato-spinner" aria-hidden="true" /> : <img src={logoLf23} alt="LF23" />}
            <h1>{titolo}</h1>
            {testo && <p>{testo}</p>}
        </div>
    </div>
);

const ReportPubblico = () => {
    const { token } = useParams();
    const [report, setReport] = useState(null);
    const [stato, setStato] = useState("caricamento"); // caricamento | ok | non-disponibile | errore

    useEffect(() => {
        let vivo = true;
        setStato("caricamento");
        axios.get(`${API_URL}/public/report/${encodeURIComponent(token)}`)
            .then((r) => { if (vivo) { setReport(r.data); setStato("ok"); } })
            .catch((e) => { if (vivo) setStato(e?.response?.status === 404 ? "non-disponibile" : "errore"); });
        return () => { vivo = false; };
    }, [token]);

    useEffect(() => {
        document.title = report?.titolo ? `${report.titolo} · LF23` : "Report attività · LF23";
    }, [report]);

    /* Stabile fra i render (e dichiarata prima dei return condizionali, come vuole la
       regola degli hook): la mappa la usa come dipendenza, e una funzione nuova ogni
       volta le farebbe rifare il riquadro da capo a ogni aggiornamento. */
    const fotoUrl = useCallback(
        (fotoId, size = "thumb") => `${API_URL}/public/report/${encodeURIComponent(token)}/foto/${fotoId}?size=${size}`,
        [token]
    );

    if (stato === "caricamento") return <Schermata titolo="Caricamento del report…" spinner />;
    if (stato === "non-disponibile") {
        return <Schermata titolo="Report non disponibile" testo="Il link non è valido oppure il report è stato disattivato. Chiedi a chi te lo ha inviato un nuovo collegamento." />;
    }
    if (stato === "errore") return <Schermata titolo="Impossibile caricare il report" testo="Si è verificato un errore. Riprova tra qualche istante." />;

    return (
        <div className="rp-pagina">
            <ReportView report={report} fotoUrl={fotoUrl} />
        </div>
    );
};

export default ReportPubblico;
